import { lazy } from 'react';

const Processors = lazy(() => import('../../admin/processors/AdminProcessorsPage'));

const ManagerProcessorsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'manager/processors',
      element: <Processors />,
    },
  ],
};

export default ManagerProcessorsConfig;
